<template lang="pug">
    div
        navbar(:opaque="true")

        section.section.search(:class="{ 'is-fullview': !wines.length || !query }")
            div.container
                div.search-bar
                    div.columns
                        div.column.is-3
                            p.is-size-20 {{ $t('page_08.text_01') }}
                        div.column
                            input.input.is-size-35.is-uppercase.is-pointer.has-text-blue(type="text", :value="query", @input="search", ref="search")
                div.columns.is-multiline
                    div.column.is-one-quarter(v-for="w in wines", v-if="wines.length")
                        wine-thumbnail.animated.fadeInUp.slow(:wine="w")

        wine-features(:w="wine", @close="wine = null", @change-wine="changeWine", v-if="wine")

        the-footer
</template>

<script>
import Navbar from '@/components/the-navbar'
import TheFooter from '@/components/the-footer'
import WineThumbnail from '@/components/wine-thumbnail'
import WineFeatures from '@/components/wine-features'

export default {
    name: 'search-view',
    components: { Navbar, TheFooter, WineThumbnail, WineFeatures },
    data () {
        return {
            winelist: [],
            wines: [],
            query: '',
            wine: null
        }
    },
    created () {
        this.getWines()
        this.$bus.$on('open-wine', w => { this.wine = w })
    },
    mounted () {
        this.$refs.search.focus()
    },
    methods: {
        async getWines () {
            const brands = await this.$api.getAll()
            const wines = brands.map(i => i.wines).flat(1).filter(i => i.sort !== '0')
            this.winelist = wines
        },

        search (ev) {
            this.query = ev.target.value

            this.query !== ''
                ? this.wines = this.winelist.filter(i => {
                    const query = this.query.toLowerCase()
                    return i.referencia.toLowerCase().includes(query) || i.categoria_nome.toLowerCase().includes(query)
                })
                : this.wines = []
        },
        changeWine (v) {
            const idx = this.wines.findIndex(i => i.id === this.wine.id)
            this.wine = this.wines[idx + v] || this.wine
        }
    }
}
</script>

<style lang="stylus" scoped>

.search
    padding-top 12.5rem
    padding-bottom 7.5rem

    &.is-fullview
        display flex
        align-items center

    .search-bar
        border-bottom 1px solid #dae1ea
        padding-bottom 2.5rem
        margin-bottom 7.5rem

        @media screen and (max-width 768px)
            padding 0 15px

        .input
            border none
            box-shadow none
            padding 0
            font-weight 200
            height auto

            &:focus, &:active
                border none
                box-shadow none

</style>
